parasails.registerPage('event-manager', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    eventID: '',
    eventTypeName: 'like',
    isLive: false,
    currentPartIndex: 0,
    currentQuestionIndex: 0,
    parts: [],
    totalClicks: [0],
    splitTotals: [0],
    confirmArchiveEventModal: false,
    newHashtagModal: false,
    ngListModal: false,
    syncing: false,
    formErrors: { /* … */ },
    cloudError: '',
    updateAllExisting: false,
    editMode: false,
    editingPart: 0,
    editableParts: ['anket', 'splash', 'thankyou', 'vote', 'qa'],
    customerNG: '',
    isOneExpanded: false,
    isShowHeaderMenu: false,
    isEditEventMode: false,
    isUndoEdit: false,
    isBtnActive: false,
    showPartControls: false,
    eventBackupData: {},
    showDeletePartConfirmation: false,
    deletePartIndex: -1,
    qrCodeData: ''
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    this.parts = this.eventData.parts;
    this.isLive = this.eventData.isLive;
    this.customerNG = this.eventData.customerNGList;
  },
  mounted: async function() {
    //{"eventid":"61f8907d96bcdd46fcfdcde7","eventType":"like","likeType":"LikeHeartPink"}
    io.socket.on(this.eventData.id, (params) => {
      switch(params.eventType) {
        case 'like':
          if(!params.weight) {params.weight = 1;}
          this.setClick(params.likeType, params.weight);
          break;
        // default:
        //   console.log('Received Socket Event with params: ' + JSON.stringify(params));
      }
    });
  },
  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    showHeaderMenu: function(){
      this.isShowHeaderMenu = !this.isShowHeaderMenu;
    },
    setClick: function(likeName, weight) {
      this.totalClicks[0] += weight;
      if(!this.splitTotals[0]) {this.splitTotals[0] = {};}
      if(!this.splitTotals[0][likeName]) {this.splitTotals[0][likeName] = 0;}
      this.splitTotals[0][likeName] += weight;
      this.$forceUpdate();
    },
    totalGrab: function (index, itemName) {
      if(this.totals[index] && this.totals[index][itemName]) {
        return this.totals[index][itemName];
      } else {
        return 0;
      }
    },
    goLive: function() {
      this.isLive = true;
      //Check for all parts. If its a mypace part, start it.
      var foundMyPace = false;
      if(this.eventData.muiltipart === true) {
        for(var i = 0; i < this.eventData.parts.length; i++) {
          this.eventData.parts[i].isLive = true;
          if(this.eventData.parts[i].mypace === true) {
            foundMyPace = true;
          }
        }
        io.socket.post('/startevent', { eventid: this.eventData.id, processmypace: foundMyPace });
        this.goLiveMultiPart();
      } else {
        for(var i = 0; i < this.eventData.parts.length; i++) {
          if(this.eventData.parts[i].mypace === true) {
            this.eventData.parts[i].isLive = true;
            foundMyPace = true;
          }
        }
        io.socket.post('/startevent', { eventid: this.eventData.id, processmypace: foundMyPace });
        this.goLivePart(0);
      }
    },
    endEvent: async function() {
      this.isLive = false;
      this.eventData.isLive = false;
      if(this.eventData.parts)
      {
        for(var p = 0; p < this.eventData.parts.length; p++) {
          this.eventData.parts[p].isLive = false;
          if(this.eventData.parts[p].questions)
          {
            for(var q = 0; q < this.eventData.parts[p].questions.length; q++) {
              this.eventData.parts[p].questions[q].isLive = false;
            }
          }
          await Cloud.editPart.with({id: this.eventData.parts[p].id, data: this.eventData.parts[p]});
        }
      }
      io.socket.post('/endevent', { eventid: this.eventData.id });
    },
    goLiveMultiPart: async function() {
      for(var i = 0; i < this.parts.length; i++) {
        this.parts[i].isLive = true;
      }
      io.socket.post('/startpart', { eventid: this.eventData.id, partid: this.parts[partIndex].id, partindex: partIndex });
    },
    goLivePart: async function(partIndex) {
      this.currentPartIndex = partIndex;
      for(var i = 0; i < this.parts.length; i++) {
        if(i !== partIndex) {
          if(this.parts[i].mypace && this.parts[i].mypace === true) {
            this.parts[i].isLive = true;
          } else {
            await this.endPart(i, false);
          }
        }
      }
      this.parts[partIndex].isLive = true;
      io.socket.post('/startpart', { eventid: this.eventData.id, partid: this.parts[partIndex].id, partindex: partIndex });
    },
    endPart: function(partIndex, includeblast = true){
      this.parts[partIndex].isLive = false;
      if(includeblast) {
        io.socket.post('/endpart', { eventid: this.eventData.id, partid: this.parts[partIndex].id, partindex: partIndex });
      }
      return;
    },
    activateQuestion: async function (partindex, questionindex) {
      //Sets this question as active...
      this.currentPartIndex = partindex;
      this.currentQuestionIndex = questionindex;
      // this.parts[partindex].isLive = true;
      // for(var i = 0; i < this.eventData.parts[partindex].questions.length; i++) {
      //   this.eventData.parts[partindex].questions[i].isLive = false;
      // }
      if(this.eventData.parts[partindex].questions[questionindex]) {
        this.eventData.parts[partindex].questions[questionindex].isLive = true;
      }
      await Cloud.editPart.with({id: this.eventData.parts[partindex].id, data: this.eventData.parts[partindex]});
      io.socket.post('/startvote', { eventid: this.eventData.id, partid: this.parts[partindex].id, partindex: partindex, voteid: questionindex});
    },
    deactivateQuestion: async function (partindex, questionindex) {
      //Sets this question as active...
      this.parts[partindex].isLive = false;
      if(this.eventData.parts[partindex].questions[questionindex]) {
        this.eventData.parts[partindex].questions[questionindex].isLive = false;
        await Cloud.editPart.with({id: this.eventData.parts[partindex].id, data: this.eventData.parts[partindex]});
      }
      io.socket.post('/endvote', { eventid: this.eventData.id, partid: this.parts[partindex].id, partindex: partindex, voteid: questionindex});
    },
    nextQuestion: function(){
      //Currently not used. activateQuestion is used now instead.
      if((this.currentPartIndex) >= this.parts.length) {
        //This is already the last part. Time to go to the next bit.
        this.currentPartIndex++;
        this.currentQuestionIndex = 0;
      } else {
        this.currentQuestionIndex++;
      }
      //io.socket.post('/showpart', { partid: this.parts[this.currentPartIndex].id, questionIndex: this.currentQuestionIndex });
    },
    showResults: function(partIndex, questionIndex){
      io.socket.post('/showresults', {eventid: this.eventData.id, partid: this.parts[partIndex].id, partindex: partIndex, voteid: questionIndex });
    },
    showCount: function(partIndex, questionIndex){
      io.socket.post('/showcount', {eventid: this.eventData.id, partid: this.parts[partIndex].id, partindex: partIndex, voteid: questionIndex });
    },
    overrideCorrectAnswer: function(partIndex, questionIndex, ondemandcorrectanswer){
      io.socket.post('/ondemandcorrect', {eventid: this.eventData.id, partid: this.parts[partIndex].id, partindex: partIndex, voteid: questionIndex, ondemandcorrectanswer: ondemandcorrectanswer });
    },
    updatePartSettings: async function(partIndex) {
      if(this.eventData.parts[partIndex]) {
        await Cloud.editPart.with({id: this.eventData.parts[partIndex].id, data: this.eventData.parts[partIndex]});
      }
      io.socket.post('/option-update', { eventid: this.eventData.id, partid: this.parts[partIndex].id, partindex: partIndex, eventPartOptions: this.eventData.parts[partIndex].eventPartOptions, updateExisting: this.updateAllExisting});
    },
    correctClass: function(isCorrect) {
      //Questions and votes are identical except that votes do not have an answer.
      if(isCorrect) {
        return 'list-group-item list-group-item-success d-flex justify-content-between align-items-start';
      } else {
        return 'list-group-item d-flex justify-content-between align-items-start';
      }
    },
    // <div v-for="(question, questionindex) in eventpart.questions" :key="question.text" :class="questionLiveClass(partindex, questionindex)">
    questionLiveClass(partindex, questionindex) {
      if(partindex === this.currentPartIndex && questionindex === this.currentQuestionIndex) {
        return 'container';
      } else {
        return 'container notlive';
      }
    },
    confirmArchive() {
      this.confirmArchiveEventModal = true;
    },
    submittedArchiveEventForm: async function() {
      //await Cloud.archive.with({id: this.eventData.id});
      this.eventData.isArchived = true;

      // Close the modal.
      this.syncing = false;
      this.$forceUpdate();
      this.confirmArchiveEventModal = false;
    },
    handleParsingArchiveEventForm: function() {
      // Clear out any pre-existing error messages.
      this.formErrors = {};

      var argins = {id: this.eventData.id}; //this.addEventFormData;

      // // If there were any issues, they've already now been communicated to the user,
      // // so simply return undefined.  (This signifies that the submission should be
      // // cancelled.)
      if (Object.keys(this.formErrors).length > 0) {
        return;
      }

      return _.omit(argins, []);
    },
    handleParsingDeletePartForm: function() {
      this.formErrors = {};

      var argins = {};

      // var argins = {
      //               eventid: this.eventData.id,
      //               partid: this.eventData.parts[this.deletePartIndex].id
      //              };

      // // If there were any issues, they've already now been communicated to the user,
      // // so simply return undefined.  (This signifies that the submission should be
      // // cancelled.)
      if (Object.keys(this.formErrors).length > 0) {
        return;
      }

      return _.omit(argins, []);
    },
    cancelArchive: function() {
      this.syncing = false;
      this.confirmArchiveEventModal = false;
    },
    cancelNG: function() {
      this.ngListModal = false;
    },
    saveNG: async function() {
      this.eventData.customerNGList = this.customerNG;
      this.ngListModal = false;
      await Cloud.savenglist.with({data: this.customerNG});
      //await Cloud.editPart.with({eventid: this.eventData.id, id: this.eventData.parts[partIndex].id, data: this.eventData.parts[partIndex]});
    },
    clearAll: function() {
      io.socket.post('/clearall', { eventid: this.eventData.id });
    },
    beginEdit: function(partIndex) {
      this.editMode = true;
      this.editingPart = partIndex;
    },
    beginCancel: function(partIndex)
    {
      this.editMode = false;
      location.reload();
    },
    beginSave: async function(partIndex) {
      this.editMode = false;
      await Cloud.editPart.with({eventid: this.eventData.id, id: this.eventData.parts[partIndex].id, data: this.eventData.parts[partIndex]});
      this.synchronize();
    },
    addOption: function(partindex, questionGroupIndex, questionIndex) {
      //Add a new option to the list...
      var inputIndex = this.eventData.parts[partindex].questiongroups[questionGroupIndex].questions[questionIndex].inputs.length;
      this.$set(this.eventData.parts[partindex].questiongroups[questionGroupIndex].questions[questionIndex].inputs, inputIndex, {
        label: '',
        type: 'radio',
        value: ''
      });
    },
    addQuestion: function(partindex, questionGroupIndex)
    {
      var questionIndex = this.eventData.parts[partindex].questiongroups[questionGroupIndex].questions.length;
      this.$set(this.eventData.parts[partindex].questiongroups[questionGroupIndex].questions, questionIndex, {
        text: '',
        identifier: '',
        inputs: [{
          label: 'Test Label',
          type: 'radio',
          value: 'Test Value'
        }]
      });
    },
    addVote: function(partindex) {
      var voteIndex = this.eventData.parts[partindex].questions.length;
      this.$set(this.eventData.parts[partindex].questions, voteIndex, {
        'has_correct_answer' : false,
        'text' : '',
        'votes' : [],
        'isLive' : false,
        'bgopacity' : '0.5',
        'borderopacity' : '0.5',
        'bgcolor' : '#ffffff',
        'resultsDisplayType': 'Bars'
      });
    },
    addVoteOption: function(partindex, questionindex) {
      var voteIndex = this.eventData.parts[partindex].questions[questionindex].votes.length;
      this.$set(this.eventData.parts[partindex].questions[questionindex].votes, voteIndex, {
        'index' : voteIndex,
        'text' : '',
        'correct' : false,
        'image' : '',
        'color' : '#000000',
        'timer' : 0,
        'bgcolor' : '#ffffff',
        'active': true
      });
    },
    addQuestionGroup: function(partindex)
    {
      var questionGroupIndex = this.eventData.parts[partindex].questiongroups.length;
      this.$set(this.eventData.parts[partindex].questiongroups, questionGroupIndex, {
        groupTitle: '',
        questions: [{
          text: '',
          identifier: '',
          inputs: [{
            label: 'Test Label',
            type: 'radio',
            value: 'Test Value'
          }]
        }]
      });
    },
    deleteOption: function(partindex, questionGroupIndex, questionIndex, optionIndex)
    {
      this.$delete(this.eventData.parts[partindex].questiongroups[questionGroupIndex].questions[questionIndex].inputs, optionIndex);
    },
    deleteQuestion: function(partindex, questionGroupIndex, questionIndex)
    {
      this.$delete(this.eventData.parts[partindex].questiongroups[questionGroupIndex].questions, questionIndex);
    },
    deleteQuestionGroup: function(partindex, questionGroupIndex)
    {
      this.$delete(this.eventData.parts[partindex].questiongroups, questionGroupIndex);
    },
    deletePartConfirmation: function(partindex) {
      this.deletePartIndex = partindex;
      this.showDeletePartConfirmation = true;
    },
    deletePart: function() {
      console.log('HERE! ' + this.deletePartIndex);
      //Delete the part
      // this.showDeletePartConfirmation = false;
      console.log('Before delete len = ' + this.eventData.parts.length);
      this.$delete(this.eventData.parts, this.deletePartIndex);
      //this.eventData.parts.splice(this.deletePartIndex, 1);
      console.log('After delete len = ' + this.eventData.parts.length);

      //await Cloud.archive.with({id: this.eventData.id});
      this.$forceUpdate();

      // Close the modal.
      this.syncing = false;
      this.showDeletePartConfirmation = false;
      this.deletePartIndex = -1;
    },
    cancelDeletePart: function() {
      //Delete the part
      this.syncing = false;
      this.deletePartIndex = -1;
      this.showDeletePartConfirmation = false;
    },
    editNGList: function() {
      this.ngListModal = true;
    },
    copyEventCodeToClipboard() {
      navigator.clipboard.writeText(this.eventData.PIN);
    },
    focusOn: function(partindex) {
      //Collapses all open parts, and expands the selected part index...
      // $('.collapse').collapse('hide');
      // $('#part' + partindex).collapse('show');
      $('.collapse').each((i, obj) => {
        if($(obj).attr('id') === 'part' + partindex)
        {$(obj).collapse('show');}
        else
        {$(obj).collapse('hide');}
      });
    },
    checkExpanded: function() {
      $('.collapse').each((i, obj) => {
        if($(obj).hasClass('show')) {
          this.isOneExpanded = true;
          return;
        }
      });
      this.isOneExpanded = false;
    },
    startEditEvent: function() {
      this.eventBackupData = this.eventData;
      this.isEditEventMode = true;
      this.showPartControls = false;
    },
    startAddPart: function() {
      this.showPartControls = !this.showPartControls;
    },
    addPart: function(partType) {
      var newEventPartData = {
        title: 'New Part',
        partType: partType,
        eventPartOptions: {
          bgMode: 'NONE'
        },
        partIndex: this.eventData.parts.length + 1,
        showQRcode: false
      };

      switch(partType) {
        case 'qr':
          newEventPartData.showQRcode = true;
          break;
        case 'like':
          newEventPartData.icons = [
            {'image' : 'icon_hart_pink_512.png','name' : 'LikeHeartPink'},
            {'image' : 'icon_hart_red_512.png', 'name' : 'LikeHeartRed'},
            {'image' : 'icon_hart_orange_512.png', 'name' : 'LikeHeartOrange'},
            {'image' : 'icon_hart_yellow_512.png', 'name' : 'LikeHeartYellow'},
            {'image' : 'icon_star_512.png', 'name' : 'LikeStarYellow'},
            {'image' : 'icon_good_512.png', 'name' : 'LikeGoodYellow'},
            {'image' : 'icon_smile_512.png', 'name' : 'LikeSmileYellow'},
            {'image' : 'icon_hart_purple_512.png', 'name' : 'LikeHeartPurple'},
            {'image' : 'icon_hart_green_512.png', 'name' : 'LikeHeartGreen'},
            {'image' : 'icon_hart_cyan_512.png', 'name' : 'LikeHeartBlue'},
            {'image' : 'icon_hart_white_512.png', 'name' : 'LikeHeartWhite'},
            {'image' : 'icon_hart_black_512.png', 'name' : 'LikeHeartBlack'}
          ];
          break;
        case 'vote':
        case 'qa':
          newEventPartData.questions = [];
          break;
        case 'tweet': newEventPartData.hashtags = []; break;
        case 'puzzle': newEventPartData.crosswordData = []; break;
        case 'anket': newEventPartData.questiongroups = []; break;
        case 'thankyou':
          newEventPartData.thankYouData = {'message' : 'Thank you!', 'submessage' : '回答が送信されました。', 'hasGift' : false};
          break;
        case 'splash':
          newEventPartData.splashScreenOptions = {
            'showLogo' : false, 'titleMessage' : 'ようこそ！', 'subText' : '', 'displaySeconds' : 0,
            'tabToContinue' : true, 'showNextButton' : true, 'nextButtonText' : '次へ',
            'instructions' : [
              'クロスワードはひらがなで入力して下さい。',
              '先頭のマスをタップすると、全ての文字を一括入力できます。',
              '途中のマスをタップすると一文字だけ入力できます。また、すべての文字において、一文字でも正解と異なる部分があると正解にはなりません'
            ]
          };
          break;
      }

      this.eventData.parts.push(newEventPartData);
      this.showPartControls = false;
    },
    showModalUndoEdit: function() {
      this.isUndoEdit = true;
    },
    hideModalUndoEdit: function(){
      this.isUndoEdit = false;
    },
    undoEditEvent: function() {
      this.eventData = this.eventBackupData;
      this.isEditEventMode = false;
      this.showPartControls = false;
      location.reload();
    },
    saveEventEdits: async function() {
      this.eventBackupData = {};
      this.isEditEventMode = false;
      this.showPartControls = false;
      await Cloud.editeventparts.with({eventid: this.eventData.id, data: this.eventData.parts, newtitle: this.eventData.title});
    },
    switchBtnActive: function() {
      this.isBtnActive = !this.isBtnActive;
    },
    synchronize: function() {
      //Sends a message informing devices they need to update their data...
      io.socket.post('/updateall', {eventid: this.eventData.id});
    }
    // async downloadReport() {
    //   //await Cloud.generatereport({eventID: this.eventData.id});
    //   await Cloud.generatereport.with({eventID: this.eventData.id});
    //   ///showresults
    // },
  }
});
